<template>
    <b-container fluid class="mt--7">
        <create-role-form
            v-if="createdMode"
            @cancel="createdMode = false"
            @success="roleCreated"
        ></create-role-form>

        <role-table v-else ref="table" @add-role="createdMode = true">
        </role-table>
    </b-container>
</template>
<script>
import RoleTable from './RoleTable'
import CreateRoleForm from './CreateRoleForm'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'roles',
    mixins: [popupMixins, permissionsMixins],
    components: {
        RoleTable,
        CreateRoleForm,
    },
    data: () => {
        return {
            createdMode: false,
            importModal: false,
        }
    },
    mounted() {
        this.$refs.table.doSearch()
    },

    methods: {
        hideModal() {
            this.createdMode = false
            this.importModal = false
            this.$refs.table.doSearch()
        },
        showAddModal() {
            this.$refs.modal.showModal()
        },
        showImportModal() {
            this.importModal = true
        },
        roleCreated() {
            this.doToast('Created!', 'Role Created', 'success')
            this.createdMode = false
        },
    },
}
</script>
<style></style>
